module.exports = __webpack_public_path__ + "img/18.d081d814.png";